module.exports = __webpack_public_path__ + "img/maanshan.3f36f40b.jpg";